import React, { Component, Suspense, lazy } from 'react'
import {
  BrowserRouter as Router, Redirect, Route, Switch,
} from 'react-router-dom'
import { connect } from 'react-redux'

import GmtAndScrollWrapper from './components/GmtAndScrollWrapper'
import LazyLoadingPage from './components/LazyLoadingPage/LazyLoadingPage'
import retry from './helpers/lazy-retry'
import Modal from 'Ui/Modal'
import { GTM_ENV } from 'Config/constants'

const Home = lazy(() => retry(() => import('./components/home/Home')))
const HomeTransfert = lazy(() => retry(() => import('./components/homeTransfert/HomeTransfert')))
const HomeCreation = lazy(() => retry(() => import('./components/homeCreation/HomeCreation')))
const SubscriptionPage = lazy(() =>
  retry(() => import('./components/SubscriptionPage/SubscriptionPage')),
)
const LeadSitePreviewPage = lazy(() =>
  retry(() => import('./components-v2/SiteSurprise/LeadSitePreviewPage')),
)
const PublicSitePage = lazy(() =>
  retry(() => import('./components-v2/SiteSurprise/PublicSitePage')),
)
const EditAddressPage = lazy(() =>
  retry(() => import('./components/EditAddressPage/EditAddressPage')),
)
const AddressPage = lazy(() => retry(() => import('./components/addressPage/AddressPage')))
const NewAddressPage = lazy(() => retry(() => import('./components/addressPage/NewAddressPage')))
const LoginPage = lazy(() => retry(() => import('./components/CustomerArea/LoginPage/LoginPage')))
const PasswordResetPage = lazy(() =>
  retry(() => import('./components/CustomerArea/PasswordResetPage/PasswordResetPage')),
)
const NewPasswordPage = lazy(() =>
  retry(() => import('./components/CustomerArea/PasswordResetPage/NewPasswordPage')),
)
const TransfertForm1 = lazy(() => retry(() => import('./components/FormaliteForms/TransfertForm1')))
const TransfertForm2 = lazy(() => retry(() => import('./components/FormaliteForms/TransfertForm2')))
const TransfertForm3 = lazy(() => retry(() => import('./components/FormaliteForms/TransfertForm3')))
const MicroTransfertForm1 = lazy(() => retry(() => import('./components/FormaliteForms/MicroTransfertForm1')))
const MicroTransfertForm2 = lazy(() => retry(() => import('./components/FormaliteForms/MicroTransfertForm2')))
const MicroCreationForm1 = lazy(() => retry(() => import('./components/FormaliteForms/MicroCreationForm1')))
const MicroCreationForm2 = lazy(() => retry(() => import('./components/FormaliteForms/MicroCreationForm2')))
const FormaliteValidatedPage = lazy(() =>
  retry(() => import('./components/FormaliteValidatedPage/FormaliteValidatedPage')),
)
const ContactUsPage = lazy(() => retry(() => import('./components/contactUsPage/ContactUsPage')))
const CustomerArea = lazy(() => retry(() => import('./components/CustomerArea/CustomerArea')))
const LegalNotice = lazy(() => retry(() => import('./components/LegalNotice/LegalNotice')))
const CGUPage = lazy(() => retry(() => import('./components/CGU/CGUPage')))
const CGVPage = lazy(() => retry(() => import('./components/CGU/CGVPage')))
const PolitiqueConfidentialitePage = lazy(() => retry(() => import('./components/CGU/PolitiqueConfidentialitePage')))
const Notification = lazy(() => retry(() => import('./components/Notification/Notification')))
const UnsubscribePage = lazy(() =>
  retry(() => import('./components/unsubscribePage/UnsubscribePage')),
)
const CreationAppointmentPage = lazy(() => retry(() => import('./components/CreationPages/CreationAppointmentPage')))
const OnboardingPage1 = lazy(() => retry(() => import('@pages/Onboarding')))
const CompanyCreationOnboardingPage = lazy(() => retry(() => import('@pages/CompanyCreationOnboarding')))
const CreationFormV2 = lazy(() => retry(() => import('./components/FormaliteFormsV2/CreationForm')))
const OffersPage = lazy(() => retry(() => import('@pages/Offers')))
const DomiciliationPage = lazy(() => retry(() => import('@pages/Domiciliation')))
const OfficesPage = lazy(() => retry(() => import('@pages/Offices')))
const PaymentPage = lazy(() => retry(() => import('@pages/Payment')))
const OnboardingPasswordPage = lazy(() => retry(() => import('@pages/OnboardingPassword')))
const HomeV2Page = lazy(() => retry(() => import('@pages/HomeV2')))
const OfficeManagerPage = lazy(() => retry(() => import('@pages/OfficeManager')))
const CreationEntrepriseLandingPage = lazy(() => retry(() => import('@pages/CreationEntreprise')))
const ExpertsComptablesPage = lazy(() => retry(() => import('@pages/ExpertsComptables')))
const McpPage = lazy(() => retry(() => import('@pages/Mcp')))
const OnboardingLoaderPage = lazy(() => retry(() => import('@pages/OnboardingLoader')))
const CreationOnboardingConfirmationPage = lazy(() => retry(() => import('@pages/CreationOnboardingConfirmation')))
const McpCreationPaiementPage = lazy(() => retry(() => import('@pages/McpCreation/Paiement')))
const McpCreationMotDePassePage = lazy(() => retry(() => import('@pages/McpCreation/MotDePasse')))

const AdminLoginPage = lazy(() => retry(() => import('@pages/AdminLogistique/LoginPage')))
const AdminSearchPage = lazy(() => retry(() => import('@pages/AdminLogistique/SearchPage')))
const AdminResultPage = lazy(() => retry(() => import('@pages/AdminLogistique/ResultPage')))


const ActualisationPage = lazy(() => retry(() => import('./components/CustomerArea/ActualisationPage/ActualisationPage')))
const JustificatifsPage = lazy(() => retry(() => import('./components/CustomerArea/JustificatifsPage/JustificatifsPage')))
const ChangeRepresentantPage = lazy(() => retry(() => import('./components/CustomerArea/ChangeRepresentantPage/ChangeRepresentantPage')))

const AdministrationsPage = lazy(() => retry(() => import('@pages/Administrations')))
const AdministrationsLoginPage = lazy(() => retry(() => import('@pages/Administrations/AdministrationsLoginPage')))

const IntegrityVerificationPage = lazy(() => retry(() => import('@pages/IntegrityVerification/IntegrityVerificationPage')))

const TestPage = lazy(() =>
  retry(() => import('./components/SubscriptionPage/TestPage')),
)


class Main extends Component {
  render() {
    return (
      <Router>
        <GmtAndScrollWrapper>
          <Suspense fallback={<LazyLoadingPage />}>
            <div className="main">
              <Switch>
                <Route path="/" exact component={HomeV2Page} />
                <Route path="/office-manager" exact component={OfficeManagerPage} />
                <Route path="/experts-comptables" exact component={ExpertsComptablesPage} />
                <Route path="/mcp" exact component={McpPage} />
                {GTM_ENV === 'staging' && (
                  <Route path="/home-transfert" exact component={HomeTransfert} />
                )}
                <Route path="/inscription/votre-site" component={LeadSitePreviewPage} />
                <Route path="/votre-site/:token" component={PublicSitePage} />
                <Route path="/inscription" component={SubscriptionPage} />
                <Route path="/inscription-prepaid/adresse" component={EditAddressPage} />
                <Route path="/adresse/:slug" component={AddressPage} />
                <Route path="/login" component={LoginPage} />
                <Route path="/reinitialisation" component={PasswordResetPage} />
                <Route path="/reinitialisation-mdp/:token" component={NewPasswordPage} />
                <Route path="/unsubscribe/:token" component={UnsubscribePage} />
                <Route path="/contact" component={ContactUsPage} />
                <Route path="/mon-compte" component={CustomerArea} />
                <Route path="/cgu" component={CGUPage} />
                <Route path="/cgv" component={CGVPage} />
                <Route path="/mentions-legales" component={LegalNotice} />
                <Route path="/politique-confidentialite" component={PolitiqueConfidentialitePage} />
                <Route path="/formalite-payment-validated" component={FormaliteValidatedPage} />
                <Route path="/transfert-de-siege" component={TransfertForm1} />
                <Route path="/transfert-de-siege-dossier" component={TransfertForm2} />
                <Route path="/transfert-de-siege-actionnaires" component={TransfertForm3} />

                {/* Ancien tunnel société (CreationForm1/2/3) : remplacé par le tunnel v2 */}
                <Redirect from="/creation-entreprise-informations" to="/creation-entreprise/dossier" />
                <Redirect from="/creation-entreprise-dossier" to="/creation-entreprise/dossier" />
                <Redirect from="/creation-entreprise-actionnaires" to="/creation-entreprise/dossier" />
                <Route path="/micro/transfert-de-siege" component={MicroTransfertForm1} />
                <Route path="/micro/transfert-de-siege-dossier" component={MicroTransfertForm2} />
                <Route path="/micro/creation-entreprise-informations" component={MicroCreationForm1} />
                <Route path="/micro/creation-entreprise-dossier" component={MicroCreationForm2} />
                {/* Refonte landing création : active sur /creation-entreprise en staging, toujours sur /creation-entreprise-v2 */}
                <Route path="/creation-entreprise-v2" exact component={CreationEntrepriseLandingPage} />
                <Route path="/creation-entreprise" exact component={CreationEntrepriseLandingPage} />
                <Route path="/creation-entreprise-rendez-vous" component={CreationAppointmentPage} />

                <Route path="/creation-entreprise/onboarding" component={CompanyCreationOnboardingPage} />
                <Route path="/creation-entreprise/onboarding-micro-entreprise" component={OnboardingPage1} />
                <Route path="/creation-entreprise/dossier" component={CreationFormV2} />

                <Route path="/creation-entreprise/enregistrement" component={OnboardingLoaderPage} />
                <Route path="/creation-entreprise/offres" component={OffersPage} />
                <Route path="/creation-entreprise/domiciliation" component={DomiciliationPage} />
                <Route path="/creation-entreprise/paiement" component={PaymentPage} />
                <Route path="/creation-entreprise/confirmation-paiement" component={CreationOnboardingConfirmationPage} />
                <Route path="/creation-entreprise/password" component={OnboardingPasswordPage} />
                <Route path="/creation-entreprise/adresses" component={OfficesPage} />

                <Route path="/creation-mcp/paiement/:publicToken" component={McpCreationPaiementPage} />
                <Route path="/creation-mcp/mot-de-passe/:publicToken" component={McpCreationMotDePassePage} />
                
                <Route path="/admin-logistique/login" component={AdminLoginPage} />
                <Route path="/admin-logistique/search" component={AdminSearchPage} />
                <Route path="/admin-logistique/result/:id" component={AdminResultPage} />
                
                <Route path="/administrations/login" component={AdministrationsLoginPage} />
                <Route path="/administrations/recherche" component={AdministrationsPage} />
                
                <Route path="/verification" component={IntegrityVerificationPage} />

                <Route path="/actualisation" component={ActualisationPage} />
                <Route path="/justificatif-representant" component={JustificatifsPage} />
                <Route path="/changement-de-representant" component={ChangeRepresentantPage} />

                {/* AB Testing */}
                <Route path="/home-v2" component={HomeV2Page} />
                <Route path="/home-v3" component={HomeV2Page} />
                <Route path="/lp1" component={Home} />
                <Route path="/home-adresses" component={HomeV2Page} />

                <Route
                  path="/not-found"
                  status={404}
                  component={({ staticContext }) => {
                    if (staticContext) {
                      staticContext.status = 404
                    }

                    return (
                      <div>
                        <h1>404 : Not Found</h1>
                      </div>
                    )
                  }}
                />
                <Route
                  status={404}
                  component={() => {
                    window.location.replace('/not-found')

                    return null
                  }}
                />
              </Switch>
            </div>
            <Notification />
          </Suspense>
          <Modal />
        </GmtAndScrollWrapper>
      </Router>
    )
  }
}

const MapStateToProps = state => ({
  currentUser: state.user.currentUser,
})

export default connect(
  MapStateToProps,
  null,
)(Main)
